/** Founder bios shown in the "About Us" section. */
export interface Founder {
  name: string;
  role: string;
  tagline: string;
  photo: string;
  email: string;
  /** Bullet points. Substrings wrapped in *asterisks* render italic, **double** render bold. */
  bullets: ReadonlyArray<string>;
}

export const founders: ReadonlyArray<Founder> = [
  {
    name: 'Adam Lesh',
    role: 'Co-Founder/CEO/CTO',
    tagline: 'Entrepreneur / Technologist / Published Author',
    photo: '/assets/adam.png',
    email: 'adam@questxr.io',
    bullets: [
      '30+ years in Entertainment Technology, Software Development, AR, and Emerging Technologies',
      'Shipped 20+ DVD choose-your-own-adventure games',
      'Founded and operated a boutique post-production facility with $5 million in annual revenue before sale',
      'Wrote short stories for the **Dragonlance** anthologies *Dragons at War* and *Dragons of Chaos* and several entries in AD&D supplements for TSR/Wizards of the Coast',
      'Ran 10+ adventures at GenCon (AD&D, GURPS, BRP)',
    ],
  },
  {
    name: 'Zachary Hunchar',
    role: 'Co-Founder/CCO',
    tagline: 'Producer / Executive / Published Author',
    photo: '/assets/zach.png',
    email: 'zach@questr.io',
    bullets: [
      '25+ years in Content Distribution (Film, TV, Packaged Media)',
      'Pioneered DVD production workflow for Lionsgate Entertainment',
      'Novel, **The Grange**, was a #1 New Release on Amazon',
      'Wrote five comic book series/graphic novels and two anthology short stories',
      'Produced 12 feature films',
      'LATAM film content distribution to 23 countries in three languages',
    ],
  },
];
